'use strict';
(function () {
    angular.module('AngularAdmin')
        .directive('pdPermissionConfigurator', ['$rootScope', '$modal', '$q', 'MembershipSvc', 'PlantSvc', 'ModalSvc', 'InvitationSvc', 'toastr', function ($root, $modal, $q, MembershipSvc, PlantSvc, ModalSvc, InvitationSvc, toastr) {
            return {
                restrict: "E",
                scope: {
                    permissionsObject: "="
                },
                templateUrl: '/static/partials/configuration/permissions.html',
                controllerAs: 'permission_configurator',
                controller: ['$scope', function ($scope) {

                    // ------------------
                    // Scope Functions
                    // ------------------
                    $scope.removeMembership = function (membership) {
                        MembershipSvc.delete(membership, $scope.plant).then(function () {
                            fetchData();
                        });
                    };

                    $scope.removeInvitation = function (invitation) {
                        InvitationSvc.delete(invitation, $scope.plant).then(function () {
                            fetchData();
                        });
                    };

                    $scope.updateMembership = function (membership) {
                        MembershipSvc.update(membership, $scope.plant).success(function () {
                            fetchData();
                        });
                    };

                    $scope.addMembership = function () {
                        var newMembership = {
                            role: $scope.new_membership.role,
                            user: $scope.new_membership.user
                        };
                        MembershipSvc.create(newMembership, $scope.plant).success(function (data) {
                            fetchData(data.id);
                        });
                    };

                    $scope.addEmployee = function () {

                        var modalInstance = ModalSvc.inviteUser.open({
                            plant: $scope.plantObj,
                            organization: $scope.plantObj.business,
                            title: "Add User"
                        });

                        modalInstance.result.then(function (data) {
                            if(data.action == 'invited') {
                                toastr.success('The invitation has been sent to the user.');
                            }
                            if(data.action == 'added') {
                                toastr.success(`The user has been added to the plant.`);
                            }
                            fetchData();
                        });
                    };

                    // ------------------
                    // Watches & Events
                    // ------------------

                    // ------------------
                    // Helpers
                    // ------------------
                    function fetchData(newItemId) {
                        var usersPromise = MembershipSvc.list_users($scope.plant);

                        var rolesPromise = MembershipSvc.list_roles($scope.plant);

                        var membershipsPromise = MembershipSvc.list($scope.plant);

                        $q.all([usersPromise, rolesPromise, membershipsPromise]).then(function (results) {
                            $scope.users = results[0].data;

                            $scope.roles = results[1].data;
                            $scope.memberships = results[2].data;

                            if ($scope.memberships.length > 0 && newItemId) {
                                var index = Array.indexByKey($scope.memberships, 'id', newItemId);
                                Array.moveItem($scope.memberships, index, $scope.memberships.length - 1);
                            }

                            getAvailableUsers();
                        });

                        InvitationSvc.list_plant_pending($scope.$root.plant, {'exclude_roles': 'customer'}).success((data) => {
                            data.forEach(function (item) {
                                item.date_invited = moment(item.date_invited).format($scope.$root.dateFormat.moment);
                            });
                            $scope.pending_invitations = data;
                        });
                    }

                    function getAvailableUsers() {
                        $scope.available_users = $scope.users.filter(function (user) {
                            for (var i = $scope.memberships.length - 1; i >= 0; i--) {
                                if ($scope.memberships[i].user == user.id)
                                    return false;
                            }
                            return true;
                        });
                    }

                    // ------------------
                    // Initialization
                    // ------------------
                    $scope.plant = $root.plant;

                    PlantSvc.get($scope.plant).then(function (result) {
                        $scope.plantObj = result.data;
                    });

                    $scope.new_membership = {};
                    fetchData();
                }]
            }
        }]);
})();